import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3476f920")

_pushScopeId("data-v-3476f920")
const _hoisted_1 = { class: "shell" }
const _hoisted_2 = {
  key: 0,
  class: "warn-test"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "custom-image-error capture-img" }
const _hoisted_5 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_secondary_nav = _resolveComponent("secondary-nav")
  const _component_search_model = _resolveComponent("search-model")
  const _component_log_location = _resolveComponent("log-location")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_el_image = _resolveComponent("el-image")
  const _component_list_pagination = _resolveComponent("list-pagination")
  const _component_enlarge_image = _resolveComponent("enlarge-image")
  const _component_export_log_dialog = _resolveComponent("export-log-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_property_bread_crumb, { headers: _ctx.breadCrumb }, null, 8, ["headers"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_secondary_nav, {
        navs: _ctx.secondMenus,
        active: _ctx.activeNavItem,
        onChoose: _ctx.changePath
      }, null, 8, ["navs", "active", "onChoose"]),
      (_ctx.type!=='auditLogs')
        ? (_openBlock(), _createBlock("label", _hoisted_2, _toDisplayString(_ctx.logSaveDaysTips), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_search_model, {
        type: _ctx.type,
        "search-data": _ctx.listRequestData.param,
        onUpdateToList: _ctx.search,
        onShowExportDialog: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowExportLog=true)),
        onUnitChange: _ctx.unitChange
      }, null, 8, ["type", "search-data", "onUpdateToList", "onUnitChange"]),
      _createVNode(_component_list_pagination, {
        headers: _ctx.headers,
        requestData: _ctx.enableRequest && _ctx.listRequestData,
        update: _ctx.updateToList,
        showCheck: _ctx.showCheck,
        action: _ctx.action,
        "save-param-in-path": _ctx.saveParamInPath,
        isSaveParamInPathInRow: true,
        "delete-url": _ctx.deleteUrl,
        deleteMultipleKeyType: "array",
        keyOfCheck: "id",
        keyOfDelete: "id",
        "show-default-action": _ctx.defaultAction
      }, {
        deviceNameSlot: _withId((data) => [
          ((_ctx.community.ProjectType.value === 'community' && _ctx.community.isNew.value) || _ctx.community.ProjectType.value === 'office')
            ? (_openBlock(), _createBlock(_component_log_location, {
                key: 0,
                location: data.scope.deviceName,
                relay: data.scope.relayName || '',
                securityRelay: data.scope.securityRelayName || ''
              }, null, 8, ["location", "relay", "securityRelay"]))
            : (_openBlock(), _createBlock("label", _hoisted_3, _toDisplayString(data.scope.deviceName), 1))
        ]),
        smallPicUrlSlot: _withId((data) => [
          _createVNode(_component_el_image, {
            class: "capture-img",
            src: data.scope.smallPicUrl,
            "preview-src-list": [data.scope.picUrl],
            "preview-teleported": true
          }, {
            error: _withId(() => [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_svg_icon, {
                  name: "icon-error",
                  color: "#a8abb2",
                  fontSize: "20px"
                })
              ])
            ]),
            _: 2
          }, 1032, ["src", "preview-src-list"])
        ]),
        captureTimeSlot: _withId((data) => [
          _createTextVNode(_toDisplayString(_ctx.dayjsFormat(data.scope.captureTime, _ctx.timeFormatMap[Number(_ctx.community.customizeForm.value) as keyof typeof _ctx.timeFormatMap])), 1)
        ]),
        startTimeSlot: _withId((data) => [
          _createTextVNode(_toDisplayString(_ctx.dayjsFormat(data.scope.startTime, _ctx.timeFormatMap[Number(_ctx.community.customizeForm.value) as keyof typeof _ctx.timeFormatMap])), 1)
        ]),
        statusSlot: _withId((data) => [
          (data.scope.status === 'abnormal')
            ? (_openBlock(), _createBlock("label", _hoisted_5, _toDisplayString(_ctx.mapWordOfTemperatureStatus[data.scope.status]), 1))
            : (_openBlock(), _createBlock("label", _hoisted_6, _toDisplayString(_ctx.mapWordOfTemperatureStatus[data.scope.status]), 1))
        ]),
        unitSlot: _withId((data) => [
          _createTextVNode(_toDisplayString(_ctx.unit==='fahrenheit'? data.scope.fahrenheit : data.scope.celsius), 1)
        ]),
        isAnswerSlot: _withId((data) => [
          _createTextVNode(_toDisplayString(data.scope.isAnswer ? data.scope.callDuration : _ctx.$wordList.NoAnswer), 1)
        ]),
        captureTypeSlot: _withId((data) => [
          _createTextVNode(_toDisplayString(_ctx.mapWordOfAction[data.scope.captureType] || '--'), 1)
        ]),
        responseSlot: _withId((data) => [
          (data.scope.action === 'callCapture')
            ? (_openBlock(), _createBlock("div", _hoisted_7, "--"))
            : (_openBlock(), _createBlock("div", _hoisted_8, _toDisplayString(_ctx.mapWordOfResponse[data.scope.response] || '--'), 1))
        ]),
        doorLogTypeSlot: _withId((data) => [
          _createTextVNode(_toDisplayString(_ctx.mapWordOfDoorLogType[data.scope.doorLogType] || '--'), 1)
        ]),
        actionSlot: _withId((data) => [
          _createTextVNode(_toDisplayString(_ctx.mapWordOfAction[data.scope.action] || '--'), 1)
        ]),
        initiatorSlot: _withId((data) => [
          _createTextVNode(_toDisplayString((data.scope.initiator === 'visitor' || data.scope.initiator === 'Unknown') ? _ctx.$wordList.visitor : data.scope.initiator || '--'), 1)
        ]),
        roomNumSlot: _withId((data) => [
          _createTextVNode(_toDisplayString(_ctx.formatApt(data.scope)), 1)
        ]),
        _: 1
      }, 8, ["headers", "requestData", "update", "showCheck", "action", "save-param-in-path", "delete-url", "show-default-action"])
    ]),
    (_ctx.isShowEnlargeImage)
      ? (_openBlock(), _createBlock(_component_enlarge_image, {
          key: 0,
          picAddress: _ctx.picAddress,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowEnlargeImage=false))
        }, null, 8, ["picAddress"]))
      : _createCommentVNode("", true),
    (_ctx.isShowExportLog)
      ? (_openBlock(), _createBlock(_component_export_log_dialog, {
          key: 1,
          title: _ctx.exportTitle[_ctx.type],
          "export-time": _ctx.exportTime,
          type: _ctx.exportType,
          onClose: _ctx.closeExportLogDialog
        }, null, 8, ["title", "export-time", "type", "onClose"]))
      : _createCommentVNode("", true)
  ]))
})